import TubCommon from "./tubCommon";

export default class ReplacementTub extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'replacement_tub';
    this.bottomTubId = "replacement_tub";
    this.visible = true;
    this.partName = 'Replacement Tub';
    this.translateId = "visualizer.bathroom.shower_tub_combo.replacement_tub";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
    if (isChild) {
      this.oneLayerPosition = true;
    }
  }

  load(dbFeature) {
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    return super.load_(dbFeature, new ReplacementTub());
  }

  navigationSubItems(filters, searchText) {
    return this.navigationSubItemsWithSides(filters, searchText);
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.TubCombo.ReplacementTub;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
  }
}
